import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const MobileCrmLoyalty = dynamic(() => import('../../components/crmAndLoyalty/MobileCrmLoyalty'), {
  loading: () => <Loading />,
})
const DesktopCrmLoyalty = dynamic(() => import('../../components/crmAndLoyalty/DesktopCrmLoyalty'), {
  loading: () => <Loading />,
})
const crmLoyalty = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>QueueBuster's CRM & Loyalty Program Features- Try It Today!</title>
        <link rel="canonical" href="https://queuebuster.co/features/customer-loyalty-program" />
        <link rel="alternate" href="https://queuebuster.co/features/customer-loyalty-program" hrefLang="en-us" />
        <meta name="description" content="Discover seamless customer management with QueueBuster's CRM & Loyalty Program features. Enhance loyalty, streamline communication & boost sales. Try it today!" />
        <meta property="og:title" content="Boost Customer Engagement: Explore QueueBuster's CRM & Loyalty Program Features!" />
        <meta property="og:description" content="Elevate customer relationships with QueueBuster's CRM & Loyalty Program features! Strengthen engagement, drive loyalty, and increase sales. Explore today for seamless customer management!" />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/New%2BOG%2BImage-05%2B(1).jpg" />
        <meta property="og:url" content="https://queuebuster.co/features/customer-loyalty-program" />
      </Head>
      <SchemaTags page="customer-loyalty-program" />
      {mobileView ? <MobileCrmLoyalty /> : <DesktopCrmLoyalty />}
    </>
  )
}

export default crmLoyalty
